// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fZ","advertDetailParameterList__header":"c-q_ga","advertDetailParameterList__list":"c-q_gb"};